import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

const Auth = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const token = searchParams.get('token')
  const tag = searchParams.get('tag')
  const navigate = useNavigate()
  useEffect(() => {
    localStorage.setItem('token', token)
    localStorage.setItem('tag', tag)
    if (tag) {
      navigate(
        `/tasks/?tag=${
          tag && tag !== 'null' && tag !== 'undefined' && tag
        }&task=&card=`
      )
    } else {
      navigate('/tasks/?tag=&task=&card=')
    }
  }, [navigate, token, tag])

  return <div />
}

export default Auth
